import { NAV_PATH } from '@/router/constants';
import { SelectItem } from '@/pages/policy/interface';

/**
 *  ==================================== 이용 약관 ====================================
 */
export const termsTab = {
	cate: '',
	title: '이용약관',
	subTab: [
		{ title: '서비스 이용약관', link: NAV_PATH.POLICY.TERMS, cate: '' },
		{ title: '홈페이지 이용약관', link: NAV_PATH.POLICY.TERMS2, cate: '' }
	]
};

export const termsSelectItem: SelectItem[] = [
	{ text: '2025년 06월 23일', link: NAV_PATH.POLICY.TERMS },
	{ text: '2025년 04월 10일', link: NAV_PATH.POLICY.TERMS }
	// { text: '2024년 02월 14일', link: NAV_PATH.POLICY.TERMS_240214 }
];

export const terms2SelectItem: SelectItem[] = [{ text: '2025년 04월 10일', link: NAV_PATH.POLICY.TERMS2 }];

export const privacyTab = {
	cate: '',
	title: '개인정보 처리방침',
	subTab: [
		{ title: '개인정보 처리방침', link: NAV_PATH.POLICY.PRIVACY, cate: '' },
		{ title: '이메일 무단수집거부', link: NAV_PATH.POLICY.PRIVACY_EMAIL, cate: '' }
	]
};
export const privacySelectItem: SelectItem[] = [
	{ text: '2025년 06월 23일', link: NAV_PATH.POLICY.PRIVACY },
	{ text: '2025년 04월 10일', link: NAV_PATH.POLICY.PRIVACY_240214 }
];
